const firebaseConfig = {
  apiKey: 'AIzaSyCwvO6PhKdK3CaXdQFlbkOX-eMyS-n4bWU',
  authDomain: 'insta-clone-nil.firebaseapp.com',
  databaseURL: 'https://insta-clone-nil.firebaseio.com',
  projectId: 'insta-clone-nil',
  storageBucket: 'insta-clone-nil.appspot.com',
  messagingSenderId: '272407893342',
  appId: '1:272407893342:web:07a6166c0f77e66a4d6bcf',
  measurementId: 'G-T3DSWKDBR2',
};

export default firebaseConfig;
